var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2290",
    "data-name": "Group 2290",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2912",
    "data-name": "Path 2912",
    d: "M0,0H22V22H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2913",
    "data-name": "Path 2913",
    d: "M13.167,13.148v1.916A5.5,5.5,0,0,0,5.833,20.25H4a7.333,7.333,0,0,1,9.167-7.1ZM11.333,12a5.5,5.5,0,1,1,5.5-5.5A5.5,5.5,0,0,1,11.333,12Zm0-1.833A3.667,3.667,0,1,0,7.667,6.5,3.666,3.666,0,0,0,11.333,10.167Zm5.5,5.5v-2.75h1.833v2.75h2.75V17.5h-2.75v2.75H16.833V17.5h-2.75V15.667Z",
    transform: "translate(-0.333 -0.083)",
    fill: "#a0a0a0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardIcon);
export default __webpack_public_path__ + "static/media/onboard-icon.b00cf476066625e5ef48a57948612df2.svg";
export { ForwardRef as ReactComponent };